import React, { useState,useEffect } from 'react'
import { components, useServices, useTranslation } from 'cng-web-lib'
import Namespace from '../../../../constants/locale/Namespace'
import { Box, Grid, Paper } from '@material-ui/core'
import { FileForUserGetUserDetails } from 'src/common/FileForUserCommon'
import AciAirKeys from 'src/constants/locale/key/AciAir'
import AciAirApiUrls from 'src/apiUrls/AciAirAcrApiUrls'
import ErrorMessageSection from 'src/views/common/ErrorMessageSection'
import WarningMessageSection from './WarningMessageSection'

const {
  button: { CngButton },
  dropzone: { CngFileUpload },
  CngDialog
} = components

function ACRCSVUploadDialog(props) {
  const { onClose, open, showNotification } = props

  const [files, setFiles] = useState([])
  const [errorMessages, setErrorMessages] = useState([])
  const [loading, setLoading] = useState(false)
  const [checkLoading, setCheckLoading] = useState(false)
  const { securedSendRequest } = useServices()
  const { translate } = useTranslation(Namespace.EHBL_MANIFEST)
  const translatedTextsObject = makeTranslatedTextsObject()

  const [warningDialog, setWarningDialog] = useState({ open: false, tableRef: null });
  const [warningMessages, setWarningMessages] = useState([])

  const [csvBlob, setCsvBlob] = useState(null);

  function makeTranslatedTextsObject() {
    let saveButton = translate(
      Namespace.ACI_AIR,
      AciAirKeys.SAVE_BUTTON
    )

    let dialogTitle = translate(
      Namespace.ACI_AIR,
      AciAirKeys.UPLOAD_CSV_DIALOG_TITLE
    )

    let successMsg = translate(
      Namespace.ACI_AIR,
      AciAirKeys.UPLOAD_CSV_SUCCESS_MSG
    )

    let errorMsg = translate(
      Namespace.ACI_AIR,
      AciAirKeys.UPLOAD_CSV_ERROR_MSG
    )

    let fileEmptyMsg = translate(
      Namespace.ACI_AIR,
      AciAirKeys.UPLOAD_CSV_FILE_EMPTY_ERROR_MSG
    )

    let discardButton = translate(
      Namespace.ACI_AIR,
      AciAirKeys.DISCARD_BUTTON
    )

    let downloadTemplateCSV = translate(
      Namespace.ACI_AIR,
      AciAirKeys.DOWNLOAD_TEMPLATE_CSV
    )

    let warningDialogTitle = translate(
      Namespace.ACI_AIR,
      AciAirKeys.UPLOAD_CSV_WARNING_DIALOG_TITLE
    )

    let warningMessage = translate(
      Namespace.ACI_AIR,
      AciAirKeys.UPLOAD_CSV_WARNING_MESSAGE
    )

    let warningConfirmationMessage = translate(
      Namespace.ACI_AIR,
      AciAirKeys.UPLOAD_CSV_WARNING_CONFIRMATION_MESSAGE
    )

    let downloadWarningMessage = translate(
      Namespace.ACI_AIR,
      AciAirKeys.UPLOAD_CSV_DOWNLOAD_WARNING_MESSAGE
    )

    let proceedButton = translate(
      Namespace.ACI_AIR,
      AciAirKeys.PROCEED_BUTTON
    )

    let cancelButton = translate(
      Namespace.ACI_AIR,
      AciAirKeys.CANCEL_BUTTON
    )

    return { 
      saveButton,
      dialogTitle, 
      successMsg, 
      errorMsg, 
      discardButton,
      fileEmptyMsg,
      downloadTemplateCSV,
      warningDialogTitle,
      warningMessage,
      warningConfirmationMessage,
      downloadWarningMessage,
      proceedButton,
      cancelButton
    }
  }

  useEffect(() => {
    setFiles([])
    setErrorMessages([])
    
    const loadCsvBlob = async () => {
      const res = await fetch(`${process.env.PUBLIC_URL}/csv/ACIAIR_ACR_Sample_Upload.csv`);
      if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
      const csvFileBlob = await res.blob();
      setCsvBlob(csvFileBlob);
    };

    loadCsvBlob().catch(console.error);
  
  }, [open]);

  const downloadCSVTemplateFile = () => {
    
    const blob = new Blob([csvBlob], { type: "text/csv" })
    const element = document.createElement("a");
    element.href = window.URL.createObjectURL(blob)
    element.download = "ACIAIR_ACR_Sample_Upload.csv";
    document.body.appendChild(element);
    element.click();
    element.parentNode.removeChild(element);
  }

  function handleCheckShipment() {

    if(files.length>0){
      try {
        setCheckLoading(true)

        let fileForUserDetails = FileForUserGetUserDetails();
        const formData = new FormData()

        formData.append('file', files[0].file)
        if (fileForUserDetails != null && fileForUserDetails != undefined) {
          formData.append("fileForUserDetails", JSON.stringify(fileForUserDetails))
        } else {
          formData.append("fileForUserDetails", "{}")
        }

        securedSendRequest.execute(
          'POST',
          AciAirApiUrls.UPLOAD_CHECK,
          formData,
          (response) => {
            if (response.status === 200) {
              if (response.data) {
                const errorMessages = response.data.errorMessages

                if (errorMessages) {
                  setWarningMessages(errorMessages)
                  setWarningDialog({open:true})
                }
              }else{
                handleUploadShipment()
              }
            }
          },
          () => {
            showNotification('error', translatedTextsObject.errorMsg)
          },
          () => setCheckLoading(false)
        )
      } catch (error) {
        console.log(error)
      }
    }else{
      showNotification('error', translatedTextsObject.fileEmptyMsg)
    }
  }

  function handleUploadShipment() {

    if(files.length>0){
      try {
        setLoading(true)

        let fileForUserDetails = FileForUserGetUserDetails();
        const formData = new FormData()

        formData.append('file', files[0].file)
        if (fileForUserDetails != null && fileForUserDetails != undefined) {
          formData.append("fileForUserDetails", JSON.stringify(fileForUserDetails))
        } else {
          formData.append("fileForUserDetails", "{}")
        }

        securedSendRequest.execute(
          'POST',
          AciAirApiUrls.UPLOAD,
          formData,
          (response) => {
            console.log(response)
            if (response.status === 200) {
              if (response.data) {
                const errorMessages = response.data.errorMessages

                if (errorMessages) {
                  setErrorMessages(errorMessages)
                  setFiles([])
                }
              }else{
                showNotification('success', translatedTextsObject.successMsg)
                onClose()
                open.tableRef.current.performRefresh()
              }
            }
          },
          () => {
            showNotification('error', translatedTextsObject.errorMsg)
            setFiles([])
          },
          () => setLoading(false)
        )
      } catch (error) {
        console.log(error)
      }
    }else{
      showNotification('error', translatedTextsObject.fileEmptyMsg)
    }
  }

  return (
    <>
    <CngDialog
      dialogTitle={translatedTextsObject.dialogTitle}
      dialogContent={
        <Paper variant='outlined'>
          <Box padding={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CngFileUpload
                  accept={['.csv']}
                  files={files}
                  maxFiles={1}
                  maxSize={1e+7}
                  onFileSelect={(file) => setFiles(file)}
                  showFormFields={false}
                  moreActions={[
                    {
                      action: 'remove',
                      name: 'Remove',
                      icon: ['fal', 'trash']
                    }
                  ]}
                  onDropRejected={(errorMessages) => showNotification('error', errorMessages)}
                />
              </Grid>
              <ErrorMessageSection errorMessages={errorMessages} />

              <Grid item xs={12}>
                <Grid container justify='flex-end' spacing={2}>
                  <Grid item xs='auto'>
                    <CngButton size='medium' variant='outlined' onClick={downloadCSVTemplateFile}>
                      {translatedTextsObject.downloadTemplateCSV}
                    </CngButton>
                  </Grid>
                </Grid>
              </Grid>

            </Grid>
          </Box>
        </Paper>
      }
      dialogAction={
        <>
          <CngButton color='secondary' disabled={loading} onClick={onClose}>
            {translatedTextsObject.discardButton}
          </CngButton>
          <CngButton
            color='primary'
            disabled={loading}
            onClick={handleCheckShipment}
            shouldShowProgress={loading}
          >
            {translatedTextsObject.saveButton}
          </CngButton>
        </>
      }
      fullWidth
      maxWidth='lg'
      open={open.open}
      onClose={onClose}
      shouldShowCloseButton
    />
    <CngDialog
      dialogTitle={translatedTextsObject.warningDialogTitle}
      dialogContent={
         <WarningMessageSection errorMessages={warningMessages} translatedTextsObject={translatedTextsObject} />    
      }
        dialogAction={
          <>
            <CngButton color='secondary' disabled={checkLoading} onClick={() => setWarningDialog({ open: false})}>
              {translatedTextsObject.cancelButton}
            </CngButton>
            <CngButton
              color='primary'
              disabled={checkLoading}
              onClick={()=>{
                setWarningDialog({open:false})
                handleUploadShipment()
              }}
              shouldShowProgress={checkLoading}
            >
              {translatedTextsObject.proceedButton}
            </CngButton>
          </>
        }
        fullWidth
        maxWidth='lg'
        open={warningDialog.open}
        onClose={() => setWarningDialog({ open: false})}
        shouldShowCloseButton
      />   
    </>
  )
}

export default ACRCSVUploadDialog
